import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { SearchResultV2 } from 'app/shared/common/search.model';
import { IFilter } from 'app/shared/models';
import { getFiltersFromSearchResults } from '@helpers';

@Component({
  selector: 'app-place-result-viewer',
  templateUrl: './place-result-viewer.component.html',
  styleUrls: ['./place-result-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlaceResultViewerComponent {
  @Input() place: SearchResultV2;

  get filters(): IFilter[] {
    return getFiltersFromSearchResults(this.place);
  }
}
